import { render, staticRenderFns } from "./SubscribeTo.vue?vue&type=template&id=47a4818c&scoped=true&"
import script from "./SubscribeTo.vue?vue&type=script&lang=js&"
export * from "./SubscribeTo.vue?vue&type=script&lang=js&"
import style0 from "./SubscribeTo.vue?vue&type=style&index=0&id=47a4818c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a4818c",
  null
  
)

/* custom blocks */
import block0 from "./SubscribeTo.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!/opt/render/project/src/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VContainer,VFlex,VLayout})
